import { getApiUrl } from "@utils/baseUrl";

export const MAX_BULK_COMPANIES = 500;

export const MAX_BULK_FILE_SIZE_MB = 10;

export const MAX_BULK_FILE_SIZE_BYTES = MAX_BULK_FILE_SIZE_MB * 1024 * 1024;

export const ACCEPTED_BULK_EXTENSIONS = [".csv", ".xls", ".xlsx"];

export const ACCEPTED_BULK_INPUT_ATTR = ACCEPTED_BULK_EXTENSIONS.join(",");

export const HIGH_CONFIDENCE_THRESHOLD = 90;

export const POTENTIAL_MATCH_THRESHOLD = 51;

// 7s. A 500-row job runs ~110s, so this cuts polls to ~16 (from ~37 at 3s)
// against a cluster that is simultaneously bulk-indexing that job's rows --
// the load that was returning TransportError(429) on the results query.
export const RESULTS_POLL_INTERVAL_MS = 7000;

export const RESULTS_POLL_TIMEOUT_MS = 5 * 60 * 1000;

// A failed poll does NOT mean the job failed -- matching runs in a worker and
// keeps going. Keep retrying through transient errors and only give up after
// this many consecutive failures.
export const MAX_CONSECUTIVE_POLL_ERRORS = 5;

export const RESULTS_PAGE_SIZE = 25;

export const RESULTS_PAGE_SIZE_OPTIONS = [25, 50, 100];

export const bulkSearchApiEndpoints = {
  upload: getApiUrl("companyBulkSearch/upload"),
  results: (searchId: string) => getApiUrl(`companyBulkSearch/${searchId}/results`),
  confirm: (searchId: string) => getApiUrl(`companyBulkSearch/${searchId}/confirm`),
  consolidated: (searchId: string) => getApiUrl(`companyBulkSearch/${searchId}/companies`),
  sample: getApiUrl("companyBulkSearch/sampleFile"),
  download: (searchId: string) => getApiUrl(`companyBulkSearch/${searchId}/download`),
  logs: getApiUrl("companyBulkSearch/logs"),
};

export const BULK_LOGS_PATH = "/company-search/bulk/logs";

// Carried in location.state so the bulk pages know to send "Go back" to the
// logs table instead of the company search page.
export const FROM_BULK_LOGS = "bulk-logs";

export const INVALID_FILE_TYPE_MSG = "Only .csv, .xls or .xlsx files are accepted.";

export const FILE_TOO_LARGE_MSG = `File is too large. Maximum allowed size is ${MAX_BULK_FILE_SIZE_MB}MB.`;

export const SAMPLE_FILE_NAME = "trademo_bulk_company_search_sample.csv";

// Only used if the server omits Content-Disposition; it normally names the
// file after the sheet the user uploaded.
export const MATCHED_COMPANIES_FILE_NAME = "matched companies.xlsx";
